import React from "react";
import { Typography } from "antd";

const Exchanges = () => {
  return (
    <>
      <Typography.Title>Exchanges</Typography.Title>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src="https://img.freepik.com/free-vector/flat-coming-soon-construction-background_1017-37083.jpg"
          alt="img"
        />
      </div>
    </>
  );
};

export default Exchanges;
